<template>
  <div class="maxman-video-page-wrapper">
    <div class="main-content maxman-video" v-if="model">
      <div class="main-content-heading">
        <h1>{{video_group.name}}</h1>
        <div class="back">
          <router-link :to="{name: 'videozone'}">&lt; späť do videozóny</router-link>
        </div>
      </div>
      <div class="heading-spliter"></div>
      <div class="text-mute">{{video_group.description}}</div>

      <div class="video-player">
        <video-player-overlay v-bind:id="model.id" v-bind:active="disabled">
          <video-player
            v-bind:thumb="model.thumb"
            v-bind:path="model.path"
            :nextVideo="video_group.nextVideo"
            :prevVideo="video_group.prevVideo"
          ></video-player>
        </video-player-overlay>
      </div>

      <div class="video-info">
        <div class="video-info--tabs">
          <div :class="['tab', {'active': !tab}]" v-on:click="tab=null">Popis</div>
          <!--<div
                  :class="['tab', {'active': tab == 'download'}]"
                  v-on:click="tab='download'"
          >Súbory na stiahnutie</div>-->
        </div>
        <div class="video-info--content" v-show="!tab">
          <div class="video-info--header">
            <h1>{{model.idx}}. {{model.name}}</h1>
          </div>
          <div class="video-info--text">
            <div class="text-mute">{{model.description}}</div>
          </div>
          <div class="video-info--numbers">
            <table>
              <!--<tr>
                          <td>Trvanie</td>
                          <td class="text-mute">{{model.duration}}</td>
                        </tr>
                        <tr>
                          <td>Skill level</td>
                          <td class="text-mute">Zaciatocnik</td>
              </tr>-->
            </table>
          </div>

          <div class="video-info--progress">
            <h3>{{video_group.name}}</h3>
            <!--<div class="wrapper-progress">
                      <video-progress value="50" />
            </div>-->
          </div>
        </div>

        <div class="video-info--content" v-show="tab == 'download'">
          <table class="video-info--download">
            <!--<tr>
                      <td>
                        <v-icon>settings</v-icon>
                      </td>
                      <td>nieco nieco</td>
                      <td>
                        <a>Stiahnuť</a>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <v-icon>settings</v-icon>
                      </td>
                      <td>nieco nieco2</td>
                      <td>
                        <a>Stiahnuť</a>
                      </td>
            </tr>-->
          </table>
        </div>
      </div>
    </div>

    <div class="video-playlist main-content">
      <router-link
        v-for="video in (!!video_group && video_group.videos || [])"
        :key="video.idx"
        :to="{name: 'video', params:{id: video.id}}"
      >
        <div :class="{'video-playlist-item': true, active: (model.id == video.id)}">
          {{video.idx}}. {{video.name}}
          <play-button v-if="(model.id != video.id)" />
        </div>
      </router-link>
    </div>
  </div>
</template>

<style lang="less" scoped>
.maxman-video-page-wrapper {
      width: 100%;
}
.maxman-video {
  .video-player {
    margin-top: 1em;
  }
}

.video-playlist {
  display: none;
  margin-top: 1em;

  @media screen and (max-width: 767.98px) {
    display: block;
  }

  .video-playlist-item {
    border: 1px solid #ccc;
    padding: 1em 2em;
    background: white;
    color: black;
    font-size: 1rem;
    font-weight: bold;
    margin-top: 0.5em;

    &.active {
      color: #ccc;
    }

    .play {
      float: right;
      margin-top: 5.5px
    }
  }
}

.video-info {
  padding-top: 1em;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
}

.video-info--content {
  display: grid;
  grid-template-areas: "header header" "text numbers" "progress progress";
  -ms-grid-template-areas: "header header" "text numbers" "progress progress";
  grid-template-columns: auto 16em;
  -ms-grid-template-columns: auto 16em;

  @media screen and (max-width: 720px) {
    grid-template-areas: "header" "text" "numbers" "progress";
    -ms-grid-template-areas: "header" "text" "numbers" "progress";
    grid-template-columns: auto;
    -ms-grid-template-columns: auto;
  }
}

.video-info--tabs {
  border-bottom: 1px solid #ccc;
  padding-left: 2em;

  .tab {
    text-transform: uppercase;
    display: inline-block;
    font-weight: bold;
    font-size: 1rem;
    padding: 1em 2em 0.5em 2em;
    &.active {
      border-bottom: 2px solid #b11116;
    }
  }
}

.video-info--header {
  grid-area: header;
  -ms-grid-area: header;
  margin: 2em 0 1em 0;
  padding-left: 2em;
  h1 {
    text-transform: uppercase;
  }
}

.video-info--text {
  grid-area: text;
  -ms-grid-area: text;
  padding: 0em 1em 2em 2em;
}

.video-info--numbers {
  grid-area: numbers;
  -ms-grid-area: numbers;
  padding: 0 2em;

  td {
    padding: 0.5em;
  }

  td.text-mute {
    text-align: right;
  }
}

.video-info--progress {
  grid-area: progress;
  -ms-grid-area: progress;
  border-top: 1px solid #ccc;
  padding: 1em 2em;
  display: flex;
  & * {
    flex: 1;
  }

  h1 {
    text-transform: uppercase;
  }

  .wrapper-progress {
    padding: 10px 0;
  }
}

.video-info--download {
  margin: 2em 3em;
}
</style>

<script>
import PlayButton from "./PlayButton";
import VideoPlayer from "./VideoPlayer";
import VideoProgress from "./VideoProgress";
import VideoPlayerOverlay from "./VideoPlayerOverlay";
import util from "../../../app/util/index";

export default {
  components: {
    VideoPlayer,
    "video-progress": VideoProgress,
    "video-player-overlay": VideoPlayerOverlay,
    "play-button": PlayButton
  },
  data() {
    return {
      video_groups: null,
      model: null,
      tab: null,
      disabled: true
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    video_group() {
      const vg =
        !!this.video_groups &&
        !!this.model &&
        util.findInArray(
          this.video_groups,
          group => group.id == this.model.video_group_id
        );

      let k = 0;
      while (vg && vg.videos && k < vg.videos.length) {
        let cur = vg.videos[k];
        if (cur.id == this.id) {
          const prevVideo = vg.videos[k - 1];
          const nextVideo = vg.videos[k + 1];

          if (nextVideo) {
            vg.nextVideo = nextVideo;
          }

          if (prevVideo) {
            vg.prevVideo = prevVideo;
          }
        }
        k++;
      }

      return vg;
    }
  },

  methods: {
    refresh() {
      this.$api.server
        .get(
          "api/public/video-groups/all?lang_id=" +
            this.$api.translator.getCurrent()
        )
        .then(r => {
          this.video_groups = r.data.video_groups;
        });

      this.$api.server.get("api/public/video/get?id=" + this.id).then(r => {
        this.$api.server
          .get("api/public/video/check-access?id=" + this.id)
          .then(r => {
            if (r.data.access) {
              this.disabled = false;
            } else {
              this.disabled = true;
            }
          });
        this.model = r.data[0];
        this.model.path = this.$api.server.prependServerUrl(
          "storage/" + this.model.path
        );
        this.model.thumb = this.$api.server.prependServerUrl(
          "storage/" + this.model.thumb
        );
      });
    }
  },
  watch: {
    id: {
      handler() {
        this.model = null;
        this.refresh();
      },
      immediate: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/Video.vue